import { render, staticRenderFns } from "./BusinessCategorySelector.vue?vue&type=template&id=166419aa&scoped=true&"
import script from "./BusinessCategorySelector.vue?vue&type=script&lang=js&"
export * from "./BusinessCategorySelector.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCategorySelector.vue?vue&type=style&index=0&id=166419aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166419aa",
  null
  
)

export default component.exports